class AvDeviceSettingsService {
    constructor(storageService, configService, config) {
        this.storageService = storageService;
        this.configService = configService;
        this.config = config;
    }

    setUsingAudioIn(deviceId) {
        this.storageService.set('audio-device', deviceId);
    }

    setUsingAudioOut(deviceId) {
        this.storageService.set('audio-output-device', deviceId);
    }

    setUsingVideo(deviceId) {
        this.storageService.set('video-device', deviceId);
    }

    setExplicitlyChosenAudioIn(deviceId, deviceLabel) {
        this.setUsingAudioIn(deviceId);
        this.setExplicitlyChosenDevicesList('explicitly-chosen-audio-input-device', deviceId, deviceLabel);
    }

    setExplicitlyChosenAudioOut(deviceId, deviceLabel) {
        this.setUsingAudioOut(deviceId);
        this.setExplicitlyChosenDevicesList('explicitly-chosen-audio-output-device', deviceId, deviceLabel);
    }

    setExplicitlyChosenVideo(deviceId, deviceLabel) {
        this.setUsingVideo(deviceId);
        this.setExplicitlyChosenDevicesList('explicitly-chosen-video-input-device', deviceId, deviceLabel);
    }

    setExplicitlyChosenDevicesList(explicitlyChosenKey, deviceId, deviceLabel) {
        let storageListKey = explicitlyChosenKey + '-list';

        this.storageService.set(explicitlyChosenKey, deviceId);

        if (!this.configService.getFixDeviceListEnabled()) return;

        let deviceListRaw = this.storageService.get(storageListKey);
        let deviceArray = deviceListRaw && deviceListRaw.length > 0 ? JSON.parse(deviceListRaw) : [];
        deviceArray.unshift(deviceLabel);
        // Should add new item to 1st position and remove last if count > config.maxCountExplicitlyChosenDeviceHistory
        if (deviceArray.findLastIndex(e => e === deviceLabel) > 0) {
            deviceArray.splice(
                deviceArray.findLastIndex(e => e === deviceLabel),
                1
            );
        }

        if (deviceArray.length > this.config.maxCountExplicitlyChosenDeviceHistory) {
            deviceArray.pop();
        }

        this.storageService.set(storageListKey, JSON.stringify(deviceArray));
    }

    getExplicitlyChosenAudioIn(devicesList) {
        return this.getExplicitlyChosenDevice('explicitly-chosen-audio-input-device', devicesList);
    }

    getExplicitlyChosenAudioOut(devicesList) {
        return this.getExplicitlyChosenDevice('explicitly-chosen-audio-output-device', devicesList);
    }

    getExplicitlyChosenVideo(devicesList) {
        return this.getExplicitlyChosenDevice('explicitly-chosen-video-input-device', devicesList);
    }

    getExplicitlyChosenDevice(explicitlyKey, devicesList) {
        if (this.configService.getFixDeviceListEnabled()) {
            const result = this.getFirstDeviceFromExplicitList(explicitlyKey, devicesList);
            if (result) {
                return result;
            }
        }

        const deviceId = this.storageService.get(explicitlyKey);
        if (!deviceId) {
            return null;
        }

        const result = devicesList.filter(d => d.deviceId === deviceId);
        return result ? result[0] : null;
    }

    getFirstDeviceFromExplicitList(key, devicesList) {
        const device = this.getFirstDeviceExistingInLocalStorage(`${key}-list`, devicesList);
        if (device) {
            this.storageService.set(key, device.deviceId);
        }

        return device;
    }

    getFirstDeviceExistingInLocalStorage(key, devicesList) {
        let storageValue = this.storageService.get(key);
        if (!storageValue || storageValue.length === 0) {
            return null;
        }

        const devicesInStore = JSON.parse(storageValue);
        if (!devicesInStore || devicesInStore.length === 0) {
            return null;
        }

        let devicesInExplicitlyList = devicesInStore.filter(e => devicesList.some(d => d.originalLabel === e));
        if (devicesInExplicitlyList.length === 0) {
            return null;
        }

        return devicesList.filter(e => e.originalLabel === devicesInExplicitlyList[0])[0];
    }
}

firebird.factory('avDeviceSettingsService', [
    'storageService',
    'configService',
    'config',
    (...deps) => new AvDeviceSettingsService(...deps)
]);
